import axios, { AxiosError, CancelTokenSource } from 'axios';
import { ApiUrls } from '../constants/apiUrls'
import { ApiResponseHelper } from '../infrastructure/utils/ApiResponseHelper'
import { IApiResponse } from '../models/ApiResponseModels'
import { AppealTopic, AppealTag, AppealAdditionalTag } from '../models/AppealReferanceModels'


export class AppealReferanceRequests {
    private cancelTokenSource?: CancelTokenSource


    public Init(): void {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    public Abort(): void {
        this.cancelTokenSource?.cancel();

    }

    public async GetAppealTopics(): Promise<IApiResponse<AppealTopic[]>> {


        return await axios.get<IApiResponse<AppealTopic[]>>(`${ApiUrls.GetAppealTopics}`,
            { cancelToken: this.cancelTokenSource?.token})
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: [], error: null, messageId: null }
                }
                return { result: false, data: [], error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }

    public async GetAppealTags(appealTopicId: string|null): Promise<IApiResponse<AppealTag[]>> {


        return await axios.get<IApiResponse<AppealTag[]>>(`${ApiUrls.GetAppealTags}?${appealTopicId!==null?`appealTopicId=${appealTopicId}`:""}`,
            { cancelToken: this.cancelTokenSource?.token})
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: [], error: null, messageId: null }
                }
                return { result: false, data: [], error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }

    public async GetAppealAdditionalTags(appealTagId: string|null): Promise<IApiResponse<AppealAdditionalTag[]>> {


        return await axios.get<IApiResponse<AppealAdditionalTag[]>>(`${ApiUrls.GetAppealAdditionalTags}?${appealTagId!==null?`appealTopicId=${appealTagId}`:""}`,
            { cancelToken: this.cancelTokenSource?.token})
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: [], error: null, messageId: null }
                }
                return { result: false, data: [], error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }


    




}
